'use client'

import { requestMillsPublic, MillsPublicClientError } from './public-client'

export type MillsCompetitionCard = { id: string; slug: string; name: string }
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export async function loadMillsCompetitionCards(
  signal?: AbortSignal
): Promise<MillsCompetitionCard[]> {
  const response = await requestMillsPublic('/api/v1/public/competitions', {
    query: { limit: 6 },
    signal,
  })
  if (!response || !Array.isArray(response.items)) {
    throw new MillsPublicClientError('MILLS_PUBLIC_DATA_INVALID')
  }
  return response.items.slice(0, 6).flatMap((item) => {
    const value = item as unknown as Record<string, unknown>
    if (
      !value ||
      value.identityWithheld === true ||
      typeof value.id !== 'string' ||
      !UUID.test(value.id) ||
      typeof value.slug !== 'string' ||
      !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value.slug) ||
      value.slug.length > 160 ||
      typeof value.name !== 'string' ||
      !value.name.trim() ||
      value.name.length > 200
    )
      return []
    // Project before React Query sees the data; never retain participant or sponsor payloads.
    return [{ id: value.id, slug: value.slug, name: value.name }]
  })
}
